import { render, staticRenderFns } from "./ProductsSelectModal.vue?vue&type=template&id=3620e84c&scoped=true&"
import script from "./ProductsSelectModal.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSelectModal.vue?vue&type=style&index=0&id=3620e84c&lang=scss&scoped=true&"
import style1 from "./ProductsSelectModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620e84c",
  null
  
)

export default component.exports